import { connect } from "react-redux";
// Component
import AdminModal from "components/AdminList/AdminModal";
// API
import api from "api";
// Action
import { openErrorDialog } from "redux/modules/errorDialog";
import {
  openConfirmDialog,
  closeConfirmDialog
} from "redux/modules/confirmDialog";
import { showSnackbar } from "redux/modules/snackbar";
import {
  changeAdminModalForm,
  closeAdminModal,
  setErrors
} from "redux/modules/adminList";

const mapStateToProps = state => ({
  adminModal: state.adminList.adminModal
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  // フォームの変更
  changeForm: (key, value) => {
    dispatch(changeAdminModalForm(key, value));
  },
  // 閉じる
  handleClose: () => dispatch(closeAdminModal()),
  // 登録
  handleRegister: admin => {
    const errors = admin.validation();
    if (errors.length > 0) {
      dispatch(setErrors(errors));
      return;
    }

    const params = { admin: admin.toJS() };
    const dialogData = {
      title: "確認",
      contentText: "管理者を登録します。よろしいですか？",
      btnLabel: "登録",
      handleClick: () => {
        api
          .post(`admins`, params)
          .then(res => {
            dispatch(closeConfirmDialog());

            if (res.errors) {
              dispatch(setErrors(res.errors));
            } else {
              dispatch(closeAdminModal());
              dispatch(showSnackbar("管理者を登録しました。"));
              ownProps.fetchAdminList();
            }
          })
          .catch(error => dispatch(openErrorDialog(error)));
      }
    };

    dispatch(setErrors([]));
    dispatch(openConfirmDialog(dialogData));
  },
  // 更新
  handleUpdate: admin => {
    const errors = admin.validation();
    if (errors.length > 0) {
      dispatch(setErrors(errors));
      return;
    }

    const params = { admin: admin.toJS() };
    const dialogData = {
      title: "確認",
      contentText: "管理者を更新します。よろしいですか？",
      btnLabel: "更新",
      handleClick: () => {
        api
          .patch(`admins/${admin.id}`, params)
          .then(res => {
            dispatch(closeConfirmDialog());

            if (res.errors) {
              dispatch(setErrors(res.errors));
            } else {
              dispatch(closeAdminModal());
              dispatch(showSnackbar("管理者を更新しました。"));
              ownProps.fetchAdminList();
            }
          })
          .catch(error => dispatch(openErrorDialog(error)));
      }
    };

    dispatch(openConfirmDialog(dialogData));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(AdminModal);



// WEBPACK FOOTER //
// ./src/containers/AdminList/AdminModalContainer.js